import { useCallback } from 'react';

import { getResetTime } from '@wwe-portal/utils/date';
import { useTimeLeft } from '@wwe-portal/ui/lib/hooks';

export const periodTypes = {
  1: 1,
  2: 2,
  3: 3,
  4: 4,
};

const periodTypeToUnit: Record<number, 'day' | 'week' | 'month' | 'year'> = {
  1: 'day',
  2: 'week',
  3: 'month',
  4: 'year',
};

export const getDateByPeriodTypes = (
  date: Date,
  periodType: number,
  duration: number
) => {
  const unit = periodTypeToUnit[periodType];
  if (unit == null) return;
  return getResetTime({
    date,
    zone: 'America/Los_Angeles',
    unit,
    duration,
  });
};

export function useMissionTimeLeft(periodType: number, onReset?: () => void) {
  const getNextStartDate = useCallback(() => {
    return getDateByPeriodTypes(new Date(), periodType, 1);
  }, [periodType]);

  const { getTimeText, now } = useTimeLeft(getNextStartDate, onReset);

  return {
    now,
    timeLeftText: () => getTimeText(),
  };
}
